export class ForgeOnboardingContainerUsage {
    constructor(model) {
        this.hasWorkspaceCustomContainer = model.workspaceHasCustomContainer;
        this.hasUserUsedCustomContainer = model.userHasUsedCustomContainer;
    }
    toRemote() {
        return {
            workspaceHasCustomContainer: this.hasWorkspaceCustomContainer,
            userHasUsedCustomContainer: this.hasUserUsedCustomContainer,
        };
    }
    toTransport() {
        return this.toRemote();
    }
    static fromTransport(model) {
        return new ForgeOnboardingContainerUsage(model);
    }
}
